import DialogAnimate from "src/components/animate/DialogAnimate";

import Context from "./context";
import DeleteAppForm from "./DeleteAppForm";
import DialogPaper from "./DialogPaper";
import DialogTitle from "./DialogTitle";

type Props = {
	show: boolean;
	onClose: () => void;
};

export default function DeleteAppDialog({ show, onClose }: Props) {
	return (
		<DialogAnimate maxWidth={"xs"} onClose={onClose} open={show}>
			<Context.Provider value={{ onClose }}>
				<DialogTitle />
				<DialogPaper />
				<DeleteAppForm />
			</Context.Provider>
		</DialogAnimate>
	);
}
